module.exports = __webpack_public_path__ + "img/icon-team-light-blue.a7a5da15.svg";